import createIcon from '../../createIcon';

/**
 * @component @name AccountBalance
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxMC41SDRWMTcuNUg3VjEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuNSAxMC41SDEwLjVWMTcuNUgxMy41VjEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIgMTkuNUgyVjIyLjVIMjJWMTkuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAxMC41SDE3VjE3LjVIMjBWMTAuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAxLjVMMiA2LjVWOC41SDIyVjYuNUwxMiAxLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccountBalance = createIcon('AccountBalance', [
  ['path', { d: 'M7 10.5H4V17.5H7V10.5Z', key: 'w7jxq2' }],
  ['path', { d: 'M13.5 10.5H10.5V17.5H13.5V10.5Z', key: '12fphp' }],
  ['path', { d: 'M22 19.5H2V22.5H22V19.5Z', key: 'm6ctwa' }],
  ['path', { d: 'M20 10.5H17V17.5H20V10.5Z', key: 'b4ote0' }],
  ['path', { d: 'M12 1.5L2 6.5V8.5H22V6.5L12 1.5Z', key: '1ts3c1' }],
]);

export default AccountBalance;
